import React, { useState } from 'react';
import { projects } from '../mockData';
import ProjectCard from '../components/ProjectCard';
import { Button } from '../components/ui/button';

const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedStatus, setSelectedStatus] = useState('All');

  const categories = ['All', ...new Set(projects.map(p => p.category))];
  const statuses = ['All', 'Completed', 'In Progress'];

  const filteredProjects = projects.filter(project => {
    const matchesCategory = selectedCategory === 'All' || project.category === selectedCategory;
    const matchesStatus = selectedStatus === 'All' || project.status === selectedStatus;
    return matchesCategory && matchesStatus;
  });

  return (
    <div className="min-h-screen bg-black text-white pt-24 pb-16 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">Projects</h1>
          <p className="text-xl text-neutral-400 max-w-3xl">
            A collection of systems I've built—ranging from security-focused backends to full-stack applications and mobile apps.
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap gap-4 mb-12">
          <div className="flex flex-wrap gap-2">
            <span className="text-sm text-neutral-500 py-2">Category:</span>
            {categories.map((category) => (
              <Button
                key={category}
                onClick={() => setSelectedCategory(category)}
                variant={selectedCategory === category ? 'default' : 'outline'}
                className={`text-sm ${
                  selectedCategory === category
                    ? 'bg-cyan-500 hover:bg-cyan-600 text-black'
                    : 'border-neutral-700 text-neutral-400 hover:bg-neutral-900 hover:text-white'
                }`}
              >
                {category}
              </Button>
            ))}
          </div>

          <div className="flex flex-wrap gap-2">
            <span className="text-sm text-neutral-500 py-2">Status:</span>
            {statuses.map((status) => (
              <Button
                key={status}
                onClick={() => setSelectedStatus(status)}
                variant={selectedStatus === status ? 'default' : 'outline'}
                className={`text-sm ${
                  selectedStatus === status
                    ? 'bg-cyan-500 hover:bg-cyan-600 text-black'
                    : 'border-neutral-700 text-neutral-400 hover:bg-neutral-900 hover:text-white'
                }`}
              >
                {status}
              </Button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        {filteredProjects.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProjects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <p className="text-neutral-400">No projects found matching your filters.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
